import React from 'react'
import { Janus, JanusLayoutRatio } from 'component-library/compositions/Janus/Janus'
import { ContentWrapper } from '../ContentWrapper/ContentWrapper'
import { BaseCompositionProps } from '../types'
import { createRegisterableComposition } from 'common/routing/page-definition'
import { ThemeMargins } from 'component-library/__styling/settings/metrics'

export interface JanusRouteProps extends BaseCompositionProps {
    hasBackgroundFill?: boolean
    verticalSpacing?: keyof ThemeMargins | undefined
    stretchColumns: boolean
    layoutRatio?: JanusLayoutRatio
    heroVideoCardHack?: boolean
}

export const JanusRegistration = createRegisterableComposition<'left' | 'right'>()(
    'janus',
    (contentAreas, props: JanusRouteProps) => (
        <ContentWrapper stretchColumns={props.stretchColumns} stretchSelf={props.stretchSelf}>
            <Janus {...props} content={[contentAreas.left, contentAreas.right]} />
        </ContentWrapper>
    )
)
